import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AvtMachineSalleComponent } from '../avt-machine-salle/avt-machine-salle.component';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { AvtListeMachineComponent } from '../avt-liste-machine/avt-liste-machine.component';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-avt-salle',
  templateUrl: './avt-salle.component.html',
  styleUrls: ['./avt-salle.component.scss'],
})
export class AvtSalleComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public router: Router
  ) {}
  exist: boolean = true;
  index: number = 0;
  disabled: boolean = false;
  disabledBtnEnregistrer: boolean = false;
  listeAllSalleIsLoadet: boolean = false;
  showDoc: boolean = false;
  listeAllSalle = [];
  salle;
  param_code: string;
  typeTrs: string;
  styleMachine: object = { width: '200px' };
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = JSON.parse(JSON.stringify(this.generalService.editorConfig)) ;
  datasourceMachine = [];
  initMachine;
  listeAllBloque = [];
  listBtnMachine = [
    {
      name: 'ajouter',
      class: 'colorBlue',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'add',
    },
  ];
  columnsMachine = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'MachineNom_Composant',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  selectedBatiment;
  @ViewChild('listeMachineComponen', { static: false })
  listeMachineComponen: AvtListesComponent;
  ngOnInit() {
    this.salle = {};
    this.selectedBatiment = {};
    this.readParamUrl();
    this.getTypeSalle();
    this.getListeBloque();
  }
  getMachineFils() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=MachineNom')
      .subscribe((colonne) => {
        colonne.read_Only = true;
        this.listeMachineComponen.setColonne(colonne);
        this.generalService
          .rechercheTable(
            'recherche/tbdata?tablere=MachineNom&param=' + this.param_code
          )
          .subscribe((machines) => {
            this.listeMachineComponen.setDataSource(machines);
            this.exist = true;
          });
      });
  }
  tabChanged(event) {
    if (this.index == 2) this.showDoc = true;
  }
  getListeBloque() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=SALL02')
      .subscribe((data) => {
        this.listeAllBloque = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getTypeSalle() {
    this.listeAllSalle = this.generalService.typeSalle;
    this.listeAllSalleIsLoadet = true;
    // this.generalService.rechercheTable(globalUrls.urlParametre+"&val=SALL01").subscribe(data =>
    // {
    //   this.listeAllSalle = this.generalService.sort(data.DiverSys,"DiverSys_Titre");
    //   this.listeAllSalleIsLoadet = true;
    // });
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'ajouter': {
        this.openDialogAjouter();
        break;
      }
      case 'supprimer': {
        this.supprimerEquipement(event.row);
        break;
      }
    }
  }
  supprimerEquipement(row) {
    if (this.generalService.isNotEmpty(this.listeMachineComponen.row)) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(
            row.MachineNom_Composant,
            'machine'
          );
          if (deleteFn != null) {
            this.exist = false;
            this.listBtnMachine[1].disabled = true;
            deleteFn.subscribe(
              (data) => {
                this.getMachineFils();
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.listBtnMachine[1].disabled = false;
              },
              (error) => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
                this.listBtnMachine[1].disabled = false;
              }
            );
          }
        }
        if (result == 'annuler') {
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  openDialogAjouter() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    var dialogRef = this.dialog.open(AvtMachineSalleComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((Machine_Code) => {
      if (Machine_Code != null) {
        this.exist = false;
        this.enregistrerMachine(Machine_Code);
      }
    });
  }
  enregistrerMachine(Machine_Code) {
    this.generalService.rechercheTable('ds/formdata?code=MachineNom').subscribe(
      (initMachine) => {
        initMachine.MachineNom[0].MachineNom_Composant = Machine_Code;
        initMachine.MachineNom[0].Machine_Code = this.param_code;
        initMachine.MachineNom[0].MachineNom_X = 0;
        initMachine.MachineNom[0].MachineNom_Y = 0;
        this.generalService.enregisterTable(initMachine).subscribe(
          (machine) => {
            this.getMachineFils();
            this.generalService.dialogSuccess('enregistré', true);
          },
          (error) => {
            this.generalService.dialogSuccess('Non enregistré', false);
            this.exist = true;
          }
        );
      },
      (error) => {
        this.generalService.dialogSuccess('Non enregistré', false);
        this.exist = true;
      }
    );
  }
  init() {
    var url: string = globalUrls.urlMachine;
    if (this.typeTrs == '2' || this.typeTrs == '3') {
      url += '&val=' + this.param_code;
      this.getMachineFils();
    }
    if (this.typeTrs == '3') {
      ////////////
      this.disabled = true;
      this.listBtnMachine.forEach((btn) => {
        btn.disabled = true;
      });
      // Angular Editor Supprimer
      // this.editorConfig.editable = false
    }

    this.getMachine(url);
  }
  getMachine(url: string) {
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.initMachine = data;
      this.salle = this.initMachine.Machine[0];
      // Machine_Famille1 = 1 => vehycule¨, equipent multimedia, equipent industruell, equipent BT
      // Machine_Famille1 = 2 => sale ,atelier
      this.salle.Machine_Famille1 = '2';
    });
  }
  blurChamp() {
    if (this.generalService.isNotEmpty(this.salle.Machine_Emp)) {
      this.generalService
        .rechercheTable(
          globalUrls.urlMachine + '&val=' + this.salle.Machine_Emp
        )
        .subscribe((batiment) => {
          this.selectedBatiment = batiment.Machine[0];
        });
    }
  }
  enregistrer(form) {
    if (form.form.valid) {
      this.exist = false;
      this.disabledBtnEnregistrer = true;
      this.generalService.enregisterTable(this.initMachine).subscribe(
        (data) => {
          this.generalService
            .rechercheTable('recherche/tbdata?tablere=machine&param=2')
            .subscribe((dataSalle) => {
              var lastCode = dataSalle
                .map((salle) => salle.Machine_Code)
                .reduce(function (a, b) {
                  return Math.max(a, b);
                });
              var lastSalle = dataSalle.find((salle) => {
                return salle.Machine_Code == lastCode;
              });
              if (this.typeTrs == '1')
                if (
                  lastSalle.Machine_Emp2 == this.salle.Machine_Emp2 &&
                  lastSalle.Machine_TR == this.salle.Machine_TR &&
                  lastSalle.Machine_Fournisseur ==
                    this.salle.Machine_Fournisseur
                ) {
                  this.param_code = lastCode;
                  this.typeTrs = '2';
                }
              this.generalService.dialogSuccess('Enregistré', true);
              this.disabledBtnEnregistrer = false;
              this.init();
              this.exist = true;
            });
        },
        (erro) => {
          this.exist = true;
          this.disabledBtnEnregistrer = false;
          this.generalService.dialogSuccess('Non enregistré', false);
        }
      );
    }
  }
  //avt/liste/machine/2

  retourListes() {
    this.generalService.popupCenter('/w/avt/liste/machine/2');
    // this.generalService.fenetreAvtListeMachine = "2";
    // this.generalService.dialogOpend = this.generalService.dialog.open(AvtListeMachineComponent, new MatDialogConfig());
    // this.exist = false;
    // this.generalService.dialogOpend.afterClosed().subscribe(() =>
    // {
    //   if( this.generalService.isNotEmpty( this.generalService.machineChoisie))
    //   {
    //     this.param_code = (this.generalService.machineChoisie.Machine_Code);
    //     this.typeTrs = "2";
    //     this.init();
    //   }
    // });
    // this.router.navigate(['avt/parametre/liste/clients/'+this.typeClient]);
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      this.init();
    });
  }
}
